<template>
    <transition name="slide-fade">
        <div class="modal" :class="{ 'open': open }" v-if="open">
            <div class="modal-content">
                <div class="bg-white w-full rounded-xl p-3 text-a-gray-555555">
                    <div class="text-center text-14 font-medium pt-1" v-html="title"></div>
                    <div class="text-center text-14 pt-5" :class="msgBodyClass" v-html="message"></div>
                    <template v-if="btnComponent == 'line'">
                        <div class="text-center">
                            <BtnOpenLine @click="clickOk()" />
                        </div>
                    </template>
                    <template v-else>
                        <div class="w-186px m-auto">
                            <button class="w-full bg-a-orange-fe5000 text-white rounded-full py-3 text-14" @click="clickOk()">
                                {{ btnOk }}
                            </button>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
import LocaleMixin from "@/mixin/LocaleMixin.js";

import BtnOpenLine from "@/components/Button/BtnOpenLine.vue";
import Utility from "@/helper/Utility";

export default {
    name: "ClaimAlertModal",
    mixins: [LocaleMixin],
    props: {
        controller: Object,
    },
    components: {
        BtnOpenLine
    },
    data: function () {
        return {
            open: false,
            title: '',
            message: '',
            modalConfig: null,
            btnOk: 'ปิด',
            busModal: null,
            btnComponent: null
        };
    },
    computed: {
        msgBodyClass: function(){
            if(this.modalConfig != null && !Utility.isEmptyStr(this.modalConfig?.msgClass)){
                return this.modalConfig.msgClass
            }
            return 'pb-4'
        }
    },
    created: function () {
        this.busModal = this.controller.busModal;
    },
    mounted: function () {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    watch: {
        '$route.path': function () {
            if (this.open) {
                this.hide();
            }
        },
    },
    methods: {
        show: function (config) {
            this.modalConfig = config
            this.title = config.title
            this.message = config.msg;
            this.btnComponent = config?.btnComponent ?? null
            this.btnOk = config?.btnOk ?? 'ปิด'

            document.body.classList.add('not-scroll');
            this.open = true;
        },
        hide: function () {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        clickOk: function () {
            this.hide();
            this.controller.sendCallbackOk();
        },
    },
}
</script>
<style lang="scss" scoped>
@import "@/style/modal.scss";

.modal {
    @extend %modal;
}
</style>
